import { Chakra } from "@airhelp/react-ui-components";
import type { FormSubmitButtonProps } from "./FormSubmitButton.d";

const { Button } = Chakra;

const FormSubmitButton = ({
  isLoading = false,
  isDisabled = false,
  text,
  ...props
}: FormSubmitButtonProps) => (
  <Button
    isLoading={isLoading}
    type="submit"
    w="full"
    minW="min-content"
    isDisabled={isDisabled}
    {...props}
  >
    {text}
  </Button>
);

export default FormSubmitButton;
